import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22760514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader fixed inset-0 bg-black bg-opacity-70 overflow-hidden" }
const _hoisted_2 = { class: "blur-container flex items-start justify-center text-center backdrop-filter backdrop-blur-sm block overflow-hidden h-full" }
const _hoisted_3 = { class: "main-container bg-white rounded-lg text-left block relative p-10 text-black-900" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "#000000",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "#000000",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("h1", null, _toDisplayString(_ctx.message), 1)
        ])
      ])
    ])
  ]))
}